import { isValidPrice } from '@domain-group/javascript-utils'

export type ProviderPriceListItemModel = {
  api_pricing_service_provider: string,
  api_pricing: boolean,
  cache_key: number,
  hidden: boolean,
  id: number,
  options?: number[],
  price: number,
  provider_price_list_id: number,
  quantity: number,
  service_product_id: number,
}

export type ProviderPriceListItemRequestOptions = {}

const state = {
  api_pricing_service_provider: '',
  api_pricing: false,
  hidden: false,
  price: 0,
  provider_price_list_id: undefined,
  quantity: 0,
  service_product_id: undefined,
}

export const requiredFields = [
  { key: 'price', validation: isValidPrice },
  { key: 'provider_price_list_id' },
  { key: 'quantity' },
  { key: 'service_product_id' },
]

export default state
